module.exports = __webpack_public_path__ + "img/us.27414395.svg";